import { useNavigate } from "@tanstack/react-router";
import { useCallback } from "react";

import { useSharedProjectChats } from "@/panes/use-project-chats";

/**
 * Open a conversation where it works: the agent panel in the explorer of its
 * task's branch, or of main. The panel's state is the shell's, so it is still
 * open on the conversation when the explorer for that branch mounts.
 */
export function useFollowConversation(projectId: string) {
  const navigate = useNavigate();
  const { openThread } = useSharedProjectChats();
  return useCallback(
    (chatId: string, taskId: string | null) => {
      openThread(chatId);
      void navigate({
        to: "/p/$projectId/$branch/explorer",
        params: { projectId, branch: taskId ?? "main" },
        search: {},
      });
    },
    [navigate, openThread, projectId],
  );
}
